module.exports = __webpack_public_path__ + "static/media/underarmour.d2f355be.jpg";